import { api } from "@/services/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"

const useCreateLevelSession = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationKey: ["create-level-session"],
    mutationFn: (levelId: string) => api.challenges.createLevelSession(levelId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-user"] })
    },
  })
  return mutation
}

export default useCreateLevelSession
